export function initials(fullName: string): string {
    const names = fullName.split(' ');
    return names[0].charAt(0) + names[names.length - 1].charAt(0);
}
